<template>
  <v-dialog
    v-model="dialog"
    max-width="800"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    transition="dialog-bottom-transition"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn class="mx-2" icon v-bind="attrs" v-on="on"> <v-icon>mdi-help-circle-outline</v-icon></v-btn>
    </template>
    <v-card flat>
      <v-card-title :style="partnerColor.gradientStyle">
        <span :style="`color:white`">{{ helpTextTitle }}</span>
        <v-spacer />
        <v-btn :color="partnerColor.primaryDarken_3" icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="mt-4">
        <p class="pt-4 text-justify">{{ helpText }}</p>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { PartnerColor } from "@/lib/partnerColor";

@Component({
  components: {}
})
export default class ThgChargingStationHelpDialog extends Vue {
  @Prop()
  helpText!: string;
  @Prop()
  helpTextTitle!: string;

  dialog = false;
  partnerColor = new PartnerColor();

  close() {
    this.dialog = false;
  }
}
</script>
